import { GET_CL_WIP_BASE_URL } from '../../constants/api';

const API_CLS_WIP_BASE_URL = GET_CL_WIP_BASE_URL;

export { API_CLS_WIP_BASE_URL };
